import script from "./[id].vue?vue&type=script&setup=true&lang=ts"
export * from "./[id].vue?vue&type=script&setup=true&lang=ts"

import "./[id].vue?vue&type=style&index=0&id=4a0f87e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a0f87e6"]])

export default __exports__